export default __webpack_public_path__ + "static/media/chevron-compact-up.37dea7c3.svg";